import React from 'react';
import TabPanes from './TabPanes';
import { TabContainer } from './styles';
import { TabMaskedDiv } from '../../../../../../CommonComponents/commonStyles';
import PropTypes from 'prop-types';

const TabContent = ({
  item,
  tabIndex,
  tabConfig,
  containerHeight,
  activeKey,
  accountType,
  scrolled,
  dashboard,
  xscroll,
  clicked, 
  isLazyLoading,
  tabPanes
}) => {
  return (
    <TabContainer
    data-test = "tabContainer"
      height={
        item.data !== 'null' &&
        typeof item.data == 'object' &&
        item.data.hasOwnProperty('length') &&
        item.data.length > 0
          ? containerHeight
          : 'auto'
      }
      noBorder
      yscroll={true}
      yscrollC
      xscroll={xscroll}
      onScroll={dashboard ? event => scrolled(event, item.title) : null}
    >
      <TabMaskedDiv />
      <TabPanes
        tabPanes={tabPanes}
        clicked={clicked}
        containerHeight={containerHeight}
        itemData={item.data}
        tabIndex={tabIndex}
        tabConfig={tabConfig}
        filters={item.options}
        destComponent={item.destComponent}
        mobComponent={item.mobComponent}
        columnConfig={item.columnConfig}
        expandConfig={item.expandConfig}
        text={item.text}
        accountType={accountType}
        activeKey={activeKey}
        isLazyLoading={isLazyLoading}
      />
    </TabContainer>
  );
};

export default TabContent;

TabContent.propTypes = {
  item: PropTypes.shape({
    data: PropTypes.array,
    destComponent: PropTypes.string,
    isLoading: PropTypes.bool,
    key: PropTypes.number,
    mobComponent: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
  }),
  tabIndex: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  tabConfig: PropTypes.func,
  containerHeight: PropTypes.string,
  activeKey: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  scrolled: PropTypes.func,
  tabPanes: PropTypes.array,
  dashboard: PropTypes.bool,
  xscroll: PropTypes.bool,
  clicked: PropTypes.func,
  isLazyLoading: PropTypes.bool,
};